export { default } from './BlockTestimonialsCard'